import * as actionTypes from "./actionTypes";
import { firebase } from "../../firebase/index";
import {
  collections,
  documents,
  constants,
} from "../../firebase/firestoreNameSpaces";
import logo from "../../assets/images/logo.png";
const crypto = require("crypto");
//  import {productData} from "../../data"

let config = {
  headers: {
    contentType: "application/json",
    //    "Cross-Origin-Embedder-Policy": "require-corp",
    //     "Cross-Origin-Opener-Policy": "same-origin",
    "Access-Control-Allow-Origin": "*",
  },
};

let url = constants.nodeserver;
// let url = "http://localhost:4000"
export const setCart = (user) => {
  return (dispatch, getState) => {
    if (user.cart) {
      if (!getState().cart.order.products.length) {
        let cart = user.cart;
        let items = [];
        for (let itemKey in cart) {
          let item = cart[itemKey];
          items.push(item);
        }
        let userName = dispatch({
          type: actionTypes.SET_CART_ORDER,
          payload: { products: items, userId: user.userId },
        });
        // dispatch({type:actionTypes.SET_CART_ORDER,payload:{userId:user.userId}})
      }
    } else {
      // alert("No items in cart")
    }
  };
};

export const fetchCartProducts = (user, includeDelivery) => {
  return async (dispatch, getState) => {
    try {
      if (user.cart) {
        let cart = user.cart;

        dispatch({
          type: actionTypes.CART_PRODUCT_CONTROLS,
          payload: { loading: true, cartProductsLoading: true },
        });

        let db = firebase.firestore();

        if (!Object.keys(cart).length) {
          return dispatch({
            type: actionTypes.CART_PRODUCT_CONTROLS,
            payload: {
              loading: false,
              cartProductsLoading: false,
              cartProducts: [],
            },
          });
        }

        let cartProductIds = [];
        for (let itemKey in cart) {
          let id = cart[itemKey].id;
          if (!cartProductIds.includes(id)) {
            cartProductIds.push(cart[itemKey].id);
          }
        }

        let fetched_products = [];

        if (cartProductIds.length <= 10) {
          let docs = (
            await db
              .collection(collections.PRODUCTS)
              .where("id", "in", cartProductIds)
              .get()
          ).docs;
          docs.map((doc) => {
            fetched_products.push(doc.data());
          });
        } else {
          for (let i = 0; i < cartProductIds.length; i++) {
            try {
              let product = (
                await db
                  .collection(collections.PRODUCTS)
                  .doc(cartProductIds[i])
                  .get()
              ).data();
              if (product) {
                fetched_products.push(product);
              }
            } catch (error) {}
          }
        }

        let cartProducts = [];
        let outOfStockProducts = [];

        let productsPrice = 0;
        let totalQuantity = 0;

        for (let itemKey in cart) {
          let pr = cart[itemKey];
          let product = fetched_products.filter((obj) => obj.id == pr.id)[0];

          if (product) {
            if (product.variable && pr.variantId) {
              let variant = product.variants.filter(
                (vr) => vr.variantId == pr.variantId
              )[0];
              if (variant) {
                variant["quantity"] = pr.quantity ? pr.quantity : 1;

                if (variant.stock) {
                  productsPrice =
                    productsPrice + variant.quantity * variant.salePrice;
                  totalQuantity += variant.quantity;
                  cartProducts.push(variant);
                } else {
                  outOfStockProducts.push(variant);
                }
              }
            } else {
              product["quantity"] = pr.quantity ? pr.quantity : 1;

              if (product.stock) {
                productsPrice =
                  productsPrice + product.quantity * product.salePrice;
                totalQuantity += product.quantity;
                cartProducts.push(product);
              } else {
                outOfStockProducts.push(product);
              }
            }
          }
        }

        let cartOrder = getState().cart.order;

        let order = {
          products: cartProducts,
          finalPrice: productsPrice,
          productsPrice: productsPrice,
          totalQuantity: totalQuantity,
          delivery: cartOrder.delivery,
        };

        if (Object.keys(cartOrder.address).length) {
          order["address"] = cartOrder.address;
          if (includeDelivery) {
            let { finalPrice, delivery } = await getDeliveryCharge(order);
            order.finalPrice = finalPrice;
            order["delivery"] = delivery;
          }
        }

        //Changing finalPrice If coupon Present..Neccesary when coupon is set and user moved back to change address or payment method.

        if (cartOrder.coupon) {
          order.finalPrice = order.finalPrice - cartOrder.coupon.netDiscount;
        }

        // dispatch({type:actionTypes.SET_CART_ORDER,payload:{products:cartProducts}})
        dispatch({
          type: actionTypes.CART_PRODUCT_CONTROLS,
          payload: {
            loading: false,
            cartProductsLoading: false,
            cartProducts: cartProducts,
            outOfStockProducts: outOfStockProducts,
          },
        });
        dispatch({ type: actionTypes.SET_CART_ORDER, payload: order });
      } else {
        dispatch({
          type: actionTypes.CART_PRODUCT_CONTROLS,
          payload: { loading: false, cartProducts: [], outOfStockProducts: [] },
        });
      }
    } catch (error) {
      dispatch({
        type: actionTypes.CART_PRODUCT_CONTROLS,
        payload: {
          loading: false,
          cartProductsLoading: false,
          cartProducts: [],
        },
      });

      alert(error);
      window.location.reload();
    }
  };
};

const getFinalPrice = (products, delivery, coupon, promotion) => {
  let finalPrice = 0;
  let productsPrice = 0;
  let totalQuantity = 0;
  products.map((pobj) => {
    totalQuantity = totalQuantity + pobj.quantity;
    productsPrice = productsPrice + pobj.quantity * pobj.salePrice; ////problem saleprice not available
  });
  finalPrice = productsPrice;
  if (delivery) {
    finalPrice = finalPrice + delivery;
  }

  if (promotion) {
    finalPrice = Math.abs(finalPrice - promotion);
  }
  if (coupon) {
    finalPrice = Math.abs(finalPrice - coupon.netDiscount);
  }
  return { finalPrice, productsPrice, totalQuantity };
};

const returnUpdatedProducts = (order, product, action, byUnit) => {
  // let productsPrice = 0;
  // let finalPrice = 0;
  let counterBtnId = product.variantId ? product.variantId : product.id;

  let existingQuantity = parseInt(
    document.getElementById(counterBtnId + "counter").value
  );
  // console.log(counterBtnId,existingQuantity)
  // console.log(order,product)
  let products = [...order.products];
  // console.log(product,products)
  let index = products.findIndex((pr) => {
    // if(pr.variable){
    //     return pr.id==product.id
    // }else{
    //     return pr.variantId==product.variantId
    // }
    if (pr.variantId) {
      return pr.variantId == product.variantId;
    } else {
      return pr.id == product.id;
    }
  });

  if (index > -1) {
    if (!product.quantity) {
      product.quantity = 0;
    }
  } else {
    product["quantity"] = 0;
  }

  if (action === "increment") {
    if (byUnit) {
      product["quantity"] = product["quantity"] + 1;
    } else {
      product["quantity"] = product["quantity"] + parseInt(existingQuantity);
    }
  } else if (action === "decrement") {
    if (byUnit) {
      product.quantity = Math.abs(product.quantity - 1);
    } else {
      product.quantity = Math.abs(product.quantity - existingQuantity);
    }
  }
  if (index > -1) {
    //product already exists
    products[index] = product;
  } else {
    //product  Not exists
    products.push(product);
  }
  // console.log(products)

  let { finalPrice, productsPrice, totalQuantity } = getFinalPrice(
    products,
    order.delivery,
    order.coupon,
    order.promotion
  );

  let updatedProduct = product;

  return { products, finalPrice, productsPrice, updatedProduct, totalQuantity };
};

export const addProductToCart = (userId, product) => {
  return async (dispatch, getState) => {
    try {
      dispatch({
        type: actionTypes.CART_PRODUCT_CONTROLS,
        payload: { loading: true },
      });
      let order = getState().cart.order;
      let user = getState().auth.user;
      let isFirstProduct = false;
      // if(!order.products.length){
      //     isFirstProduct = true
      // }

      let {
        products,
        finalPrice,
        productsPrice,
        updatedProduct,
        totalQuantity,
      } = returnUpdatedProducts(order, product, "increment", false);
      // let cartProductObj = {id:updatedProduct.id,variantId:updatedProduct.variable?null:updatedProduct.variantId,quantity:updatedProduct["quantity"]};
      // let cartProductId =  updatedProduct.variable?updatedProduct.id:updatedProduct.variantId;
      let cartProductObj = {
        id: updatedProduct.id,
        variantId: updatedProduct.variantId ? updatedProduct.variantId : null,
        quantity: updatedProduct["quantity"],
      };
      let cartProductId = updatedProduct.variantId
        ? updatedProduct.variantId
        : updatedProduct.id;

      let db = firebase.firestore();
      await db
        .collection(collections.USERS)
        .doc(userId)
        .set({ cart: { [cartProductId]: cartProductObj } }, { merge: true });
      dispatch({
        type: actionTypes.SET_CART_ORDER,
        payload: { finalPrice, productsPrice, products, totalQuantity },
      });
      dispatch({
        type: actionTypes.CART_PRODUCT_CONTROLS,
        payload: { loading: false },
      });

      user.cart[cartProductId] = cartProductObj;
      dispatch({ type: actionTypes.SET_USER, payload: { user } });
      // if(isFirstProduct){
      //     window.location.reload()
      // }
    } catch (error) {
      dispatch({
        type: actionTypes.CART_PRODUCT_CONTROLS,
        payload: { loading: false },
      });
      return alert(error);
    }
  };
};

export const addProductSyncronously = (
  userId,
  product,
  action,
  includeDeliveryComputation
) => {
  return (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      try {
        dispatch({
          type: actionTypes.CART_PRODUCT_CONTROLS,
          payload: { loading: true },
        });
        let order = getState().cart.order;
        let user = { ...getState().auth.user };

        let {
          products,
          finalPrice,
          productsPrice,
          updatedProduct,
          totalQuantity,
        } = returnUpdatedProducts(order, product, action, true);

        // let cartProductObj = {id:updatedProduct.id,variantId:updatedProduct.variable?null:updatedProduct.variantId,quantity:updatedProduct["quantity"]};
        // let cartProductId =  updatedProduct.variable?updatedProduct.id:updatedProduct.variantId;
        let cartProductObj = {
          id: updatedProduct.id,
          variantId: updatedProduct.variantId ? updatedProduct.variantId : null,
          quantity: updatedProduct["quantity"],
        };
        let cartProductId = updatedProduct.variantId
          ? updatedProduct.variantId
          : updatedProduct.id;

        //Updating Cart in Database
        let db = firebase.firestore();
        await db
          .collection(collections.USERS)
          .doc(userId)
          .set({ cart: { [cartProductId]: cartProductObj } }, { merge: true });

        if (!includeDeliveryComputation) {
          //Updating the products, its price in redux store
          dispatch({
            type: actionTypes.SET_CART_ORDER,
            payload: { finalPrice, productsPrice, products, totalQuantity },
          });

          //Updating the user cart in the redux store
          let userCart = user.cart;
          userCart[cartProductId] = cartProductObj;
          user.cart = userCart;
          dispatch({ type: actionTypes.SET_USER, payload: { user: user } });
          return resolve(true);
        }

        //Setting Delivery Charge on product quantity update

        getDeliveryCharge(
          {
            finalPrice,
            products,
            address: order.address,
            delivery: order.delivery,
          },
          true
        )
          .then((response) => {
            let { finalPrice, delivery } = response;

            //Updating the products, its price in redux store
            dispatch({
              type: actionTypes.SET_CART_ORDER,
              payload: {
                finalPrice,
                productsPrice,
                products,
                delivery,
                totalQuantity,
              },
            });

            //Updating the user cart in the redux store
            let userCart = user.cart;
            userCart[cartProductId] = cartProductObj;
            user.cart = userCart;
            dispatch({ type: actionTypes.SET_USER, payload: { user: user } });

            //Cart Loading
            dispatch({
              type: actionTypes.CART_PRODUCT_CONTROLS,
              payload: { loading: false },
            });
            resolve(true);
          })
          .catch(async (error) => {
            alert(error);
            if (cartProductObj.quantity > -1) {
              //Rollback Product Counter
              cartProductObj["quantity"] = cartProductObj.quantity - 1;
              await db
                .collection(collections.USERS)
                .doc(userId)
                .set(
                  { cart: { [cartProductId]: cartProductObj } },
                  { merge: true }
                );
              //Rollback the products, its price in redux store
              dispatch({
                type: actionTypes.SET_CART_ORDER,
                payload: {
                  finalPrice: order.finalPrice,
                  productsPrice: order.productsPrice,
                  products: order.products,
                },
              });

              //Rollback the user cart in the redux store
              let userCart = user.cart;
              userCart[cartProductId] = cartProductObj;
              user.cart = userCart;
              dispatch({ type: actionTypes.SET_USER, payload: { user: user } });

              //Cart Loading
              dispatch({
                type: actionTypes.CART_PRODUCT_CONTROLS,
                payload: { loading: false },
              });
              resolve(true);
              alert("Something went wrong");
            }
          });
      } catch (error) {
        dispatch({
          type: actionTypes.CART_PRODUCT_CONTROLS,
          payload: { loading: false },
        });
        reject(error);
        //    return alert(error)
      }
    });
  };
};

export const removeProductFromCart = (
  userId,
  product,
  includeDeliveryComputation
) => {
  return async (dispatch, getState) => {
    try {
      dispatch({
        type: actionTypes.CART_PRODUCT_CONTROLS,
        payload: { loading: true },
      });
      let order = getState().cart.order;
      let cartProducts = getState().cart.cartProducts.concat();
      let orderProducts = getState().cart.order.products;

      let user = getState().auth.user;
      let userBackup = user;
      let productId = product.variantId ? product.variantId : product.id;
      let idname = product.variantId ? "variantId" : "id";

      let filteredCartProducts = cartProducts.filter(
        (cp) => cp[idname] != product[idname]
      );
      let filteredOrderProducts = orderProducts.filter(
        (op) => op[idname] != product[idname]
      );

      let db = firebase.firestore();
      await db
        .collection(collections.USERS)
        .doc(userId)
        .set(
          { cart: { [productId]: firebase.firestore.FieldValue.delete() } },
          { merge: true }
        );

      if (includeDeliveryComputation) {
        let { finalPrice, productsPrice, totalQuantity } = getFinalPrice(
          filteredOrderProducts,
          order.delivery,
          order.coupon,
          order.promotion
        );
        let orderObj = { ...order };
        orderObj.finalPrice = finalPrice;
        orderObj.productsPrice = productsPrice;
        orderObj.products = filteredOrderProducts;
        getDeliveryCharge(orderObj, true)
          .then((response) => {
            //Updating the products, its price in redux store
            dispatch({
              type: actionTypes.SET_CART_ORDER,
              payload: {
                finalPrice: response.finalPrice,
                productsPrice,
                delivery: response.delivery,
                products: filteredOrderProducts,
                totalQuantity,
              },
            });
            dispatch({
              type: actionTypes.CART_PRODUCT_CONTROLS,
              payload: { loading: false, cartProducts: filteredCartProducts },
            });
            delete user.cart[productId];
            dispatch({ type: actionTypes.SET_USER, payload: { user } });
          })
          .catch(async (error) => {
            //Rollback
            let { id, quantity, variantId } = product;
            let cartProduct = {
              id,
              quantity,
              variantId: variantId ? variantId : "",
            };
            await db
              .collection(collections.USERS)
              .doc(userId)
              .set({ cart: { [productId]: cartProduct } }, { merge: true });

            //  dispatch({type:actionTypes.SET_USER,payload:{userBackup}})

            //  dispatch({type:actionTypes.CART_PRODUCT_CONTROLS,payload:{
            //      cartProducts:cartProducts
            //  }})
            //  dispatch({type:actionTypes.SET_CART_ORDER,payload:{
            //      products:orderProducts
            //  }})
            dispatch({
              type: actionTypes.CART_PRODUCT_CONTROLS,
              payload: { loading: false },
            });

            return alert(error);
          });
      } else {
        let { finalPrice, productsPrice, totalQuantity } = getFinalPrice(
          filteredOrderProducts,
          order.delivery,
          order.coupon,
          order.promotion
        );
        delete user.cart[productId];
        dispatch({ type: actionTypes.SET_USER, payload: { user } });
        dispatch({
          type: actionTypes.SET_CART_ORDER,
          payload: {
            products: filteredOrderProducts,
            finalPrice: finalPrice,
            productsPrice: productsPrice,
            totalQuantity,
          },
        });
        dispatch({
          type: actionTypes.CART_PRODUCT_CONTROLS,
          payload: { loading: false, cartProducts: filteredCartProducts },
        });
      }

      if (cartProducts.length == 1) {
        // window.location.href = "/cart"
        // window.history.back()
        window.location.reload();
      }
    } catch (error) {
      dispatch({
        type: actionTypes.CART_PRODUCT_CONTROLS,
        payload: { loading: false },
      });
      return alert(error);
    }
  };
};

export const onSelectPaymentType = (payment) => {
  return (dispatch) => {
    if (payment == constants.PAYMENT_CASH) {
      dispatch({
        type: actionTypes.SET_CART_ORDER,
        payload: { payment_mode: constants.PAYMENT_CASH },
      });
    } else if (payment == constants.PAYMENT_ONLINE_ORDER) {
      dispatch({
        type: actionTypes.SET_CART_ORDER,
        payload: { payment_mode: constants.PAYMENT_ONLINE_ORDER },
      });
    }
  };
};
export const setOrderSummary = () => {
  return (dispatch, getState) => {
    // alert("OrderSummary")
    let order = getState().cart.order;
    let orderSummary = {};
    let finalPrice = order.finalPrice;

    orderSummary["Items"] = order.productsPrice;
    if (order.delivery) {
      orderSummary["Delivery"] = order.delivery;
      // finalPrice = finalPrice + order.delivery;
    } else {
      order.delivery = 0;
      orderSummary["Delivery"] = 0;
    }

    if (order.coupon) {
      orderSummary["Coupon"] = order.coupon.netDiscount;
      //    finalPrice = finalPrice - order.coupon.netDiscount;
    }
    if (order.promotion) {
      orderSummary["Promotion Applied"] = order.promotion;
      //    finalPrice = finalPrice - order.promotion;
    }

    orderSummary["Total"] = finalPrice;
    //    orderSummary["Total"] = order.productsPrice + order.delivery
    dispatch({
      type: actionTypes.CART_PRODUCT_CONTROLS,
      payload: { orderSummary: orderSummary },
    });
  };
};
export const setCartOnProductsChange = (order) => {
  return (dispatch) => {
    let cartProducts = [];
    let orderProducts = order.products;
    dispatch({
      type: actionTypes.CART_PRODUCT_CONTROLS,
      payload: { cartProducts: orderProducts },
    });
  };
};
export const verifyCoupon = (couponCode, price, order) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.CART_PRODUCT_CONTROLS,
      payload: {
        couponAddBtnLoading: true,
        response: "Verifying Coupon!",
        responseDisplay: "d-block",
      },
    });

    let body = {
      userId: order.userId,
      price: price,
      couponName: couponCode,
    };

    var verifyCoupon = firebase.functions().httpsCallable("verifyCoupon");
    verifyCoupon(body)
      // axios.post(`${url}/verifyCoupon`,body)
      .then((response) => {
        let coupon = response.data;

        let { maxDiscount, discountPercentage } = coupon;
        let discountFromPercent = price * (discountPercentage / 100);
        let netDiscount = Math.min(
          Math.round(discountFromPercent),
          maxDiscount
        );
        coupon.netDiscount = netDiscount;
        dispatch({
          type: actionTypes.CART_PRODUCT_CONTROLS,
          payload: {
            couponAddBtnLoading: false,
            disabled: true,
            displayRemove: "block",
            displayApply: "none",
            couponValue: netDiscount,
            responseDisplay: "d-none",
            couponCode: couponCode,
          },
        });
        dispatch({
          type: actionTypes.SET_COUPON,
          payload: {
            coupon: coupon,
            finalPrice: order.finalPrice - netDiscount,
          },
        });
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.CART_PRODUCT_CONTROLS,
          payload: {
            couponAddBtnLoading: false,
            responseDisplay: "d-none",
          },
        });
        //    console.log(err)
        alert(err.message);
        if (order.coupon) {
          dispatch(removeCoupon(couponCode));
        }
      });
  };
};

export const removeCoupon = (order, couponCode) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.CART_PRODUCT_CONTROLS,
      payload: {
        couponRemoveBtnLoading: true,
        response: "Removing Coupon!",
        responseDisplay: "d-block",
        couponCode: couponCode,
      },
    });
    setTimeout(() => {
      dispatch({
        type: actionTypes.CART_PRODUCT_CONTROLS,
        payload: {
          disabled: false,
          displayRemove: "none",
          displayApply: "block",
          couponRemoveBtnLoading: false,
          couponValue: 0,
          responseDisplay: "d-none",
        },
      });
      dispatch({
        type: actionTypes.SET_COUPON,
        payload: {
          coupon: null,
          finalPrice: order.finalPrice + order.coupon.netDiscount,
        },
      });
    }, 1000);
  };
};

export const checkServiceAvailability = (pincode, payment_mode) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      let md_available = {
        [constants.PAYMENT_CASH]: false,
        [constants.PAYMENT_ONLINE]: false,
      };

      try {
        // let postal_code = (await axios.post(`${url}/checkServiceAvailability`,{pincode})).data;

        let response = await firebase
          .functions()
          .httpsCallable("checkServiceAvailability")({ pincode });
        let postal_code = response.data;

        if (postal_code) {
          //Servicable

          if (postal_code[constants.PAYMENT_CASH.toLowerCase()] == "Y") {
            md_available[constants.PAYMENT_CASH] = true;
          }

          if (postal_code[constants.PAYMENT_ONLINE.toLowerCase()] == "Y") {
            md_available[constants.PAYMENT_ONLINE] = true;
          }
          return resolve(md_available);
        } else {
          //Not Serviceable
          dispatch({
            type: actionTypes.SET_CART_ORDER,
            payload: { payment_mode: "" },
          });
          return resolve(md_available);
        }
      } catch (error) {
        dispatch({
          type: actionTypes.SET_CART_ORDER,
          payload: { payment_mode: "" },
        });
        alert(error);
        console.log(error);
        return resolve(md_available);
      }
    });
  };
};

export const getDeliveryCharge = (order, isViaProductCounter) => {
  return new Promise(async (resolve, reject) => {
    try {
      // console.log(order)
      if (order.finalPrice) {
        //Applying Delivery Charge
        let products = order.products;
        let pincode = order.address.pincode;
        let cgm = 0;
        products.map((product) => {
          cgm = cgm + product.quantity * product.weight;
        });

        //  let result = (await axios.post(`${url}/getDeliveryCharge`,{d_pin: pincode, cgm})).data;
        let result = (
          await firebase.functions().httpsCallable("getDeliveryCharge")({
            d_pin: pincode,
            cgm,
          })
        ).data;
        let deliveryCharge = parseInt(result[0].total_amount);
        let totalPrice = 0;
        if (isViaProductCounter) {
          // When updating counter the previous delivery added must be removed and replaced by new one.
          totalPrice = order.finalPrice + deliveryCharge - order.delivery;
        } else {
          totalPrice = order.finalPrice + deliveryCharge;
        }

        //  dispatch({type:actionTypes.SET_CART_ORDER,payload:{finalPrice:totalPrice,delivery:deliveryCharge}})
        return resolve({ finalPrice: totalPrice, delivery: deliveryCharge });
      } else {
        ///Here we can make delivery zero if we want
        return resolve({
          finalPrice: order.finalPrice,
          delivery: order.delivery,
        });
      }
    } catch (error) {
      return reject(error);
    }
  });
};
const verifySignature = (key, message, receieved_signature) => {
  const hmac = crypto.createHmac("sha256", key);
  hmac.update(message);
  const expected_signature = hmac.digest("hex");
  console.log("Expected Signature", expected_signature);
  if (expected_signature === receieved_signature) {
    console.log("Siganture Matched");
    return true;
  }
  return false;
};
const onPaymentSuccess = (response) => {
  console.log("Verification Started");
  let { razorpay_payment_id, razorpay_order_id, razorpay_signature } = response;
  console.log(razorpay_payment_id, razorpay_order_id, razorpay_signature);
  const message = razorpay_order_id + "|" + razorpay_payment_id;
  verifySignature("exF8GC3tOtovtdGrTITrbCm4", message, razorpay_signature);

  // alert("Payment Successful");
  // let REACT_APP_DEVELOPMENT_ORDER_SERVER="https://yesdoneorderserver.herokuapp.com"
  // let REACT_APP_DEVELOPMENT_ORDER_SERVER =
  //   "https://yesdoneorderserver.herokuapp.com";
  // // let nodeserver = process.env.REACT_APP_DEVELOPMENT_ORDER_SERVER;
  // let nodeserver = REACT_APP_DEVELOPMENT_ORDER_SERVER;
  // axios
  //   .post(`${nodeserver}/verifyOrder`, response)
  //   .then((res) => {
  //     // console.log(res.data);
  //     alert("Payment Successful");
  //     window.location.reload()
  //     window.location.reload();
  //   })
  //   .catch((err) => console.log(err));
};
export const payOnline = (order) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.CART_PRODUCT_CONTROLS,
      payload: { loading: true },
    });

    try {
      let description = "";
      order.products.map((orderObj, index) => {
        let punctuation = index == order.products.length - 1 ? "." : ", ";
        description += orderObj.productTitle + punctuation;
      });
      order["products_desc"] = description;
      let nodeserver = "";

      var proceedToPayment = firebase.functions().httpsCallable("addOrder");
      proceedToPayment(order)
        // axios.post(`${url}/addOrder`,order)
        .then((response) => {
          //   console.log(response);
          let options = response.data;
          options["image"] = logo;

          options["description"] = description;
          // options["handler"] = onPaymentSuccess;
          options["name"] = "K5fitness.in";
          options["prefill"] = {
            name: order.address.firstname + " " + order.address.lastname,
            contact: order.address.phone,
          };
          options["theme"] = { color: "#3399cc" };
          options["callback_url"] = url + "/verifyOrder";
          options["redirect"] = true;
          const rzp1 = new window.Razorpay(options);

          // rzp1.on("payment.failed", onPaymentFailure);
          rzp1.open();

          dispatch({
            type: actionTypes.CART_PRODUCT_CONTROLS,
            payload: {
              loading: false,
            },
          });
        })
        .catch((error) => {
          dispatch({
            type: actionTypes.CART_PRODUCT_CONTROLS,
            payload: {
              loading: false,
            },
          });

          return alert(error.message);
        });
    } catch (error) {
      dispatch({
        type: actionTypes.CART_PRODUCT_CONTROLS,
        payload: {
          loading: false,
        },
      });

      return alert(error.message);
    }
  };
};

export const payCod = (order) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.CART_PRODUCT_CONTROLS,
      payload: { loading: true },
    });

    var proceedToPayment = firebase.functions().httpsCallable("payCod");
    proceedToPayment(order)
      // axios.post(`${url}/payCod`,order)
      .then((response) => {
        dispatch({
          type: actionTypes.CART_PRODUCT_CONTROLS,
          payload: { loading: false },
        });
        alert(response.data);
        return window.location.replace("/myBookings");
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.CART_PRODUCT_CONTROLS,
          payload: { loading: false },
        });
        console.log(err);
        return alert(err.message);
      });
  };
};
